import { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { RouterPaths } from '@/constants/router';
import { CommonMenu } from '@/entities/auth/ui/common-menu';

import cls from './styles.module.pcss';
import layoutCls from '@shared/assets/styles/modules/layout.module.pcss';
import Logo from '@shared/assets/images/mk-logo.svg';


export function Header({ className }: HTMLAttributes<any>) {
  const { t } = useTranslation();

  return (
    <header className={cn(cls.Header, layoutCls.Container, className)}>
      <CommonMenu />

      <Link to={RouterPaths.INDEX}>
        <img className={cls.Logo} src={Logo} alt={t('common.logo_alt')} />
      </Link>
    </header>
  );
}
